"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCheckoutOffers = exports.checkoutOffersContextDefaultValue = exports.checkoutOffersContext = exports.CheckoutOffersProvider = void 0;
var _checkoutUtils = require("@ori/checkout-utils");
var _culture = require("@ori/culture");
var _staticApiClientReact = require("@ori/static-api-client-react");
var _react = require("react");
var _constants = require("../constants");
var _jsxRuntime = require("react/jsx-runtime");
const checkoutOffersContextDefaultValue = exports.checkoutOffersContextDefaultValue = {
  isHeartFormat: false,
  showDebugInfo: false
};
const checkoutOffersContext = exports.checkoutOffersContext = /*#__PURE__*/(0, _react.createContext)(checkoutOffersContextDefaultValue);

/**
 * Provider for the offers context with data shared between offers.
 */
const CheckoutOffersProvider = ({
  children
}) => {
  const {
    culture
  } = (0, _culture.useCulture)();
  const pointFormatCurrency = culture?.pointsFormat?.currency ?? _staticApiClientReact.StaticCulturePointsFormatDtoCurrency.Points;
  const isHeartFormat = pointFormatCurrency === _staticApiClientReact.StaticCulturePointsFormatDtoCurrency.Hearts;
  const showDebugInfo = (0, _checkoutUtils.getLogLevel)(_constants.APP_NAME) === _checkoutUtils.LogLevel.Debug;
  const value = (0, _react.useMemo)(() => ({
    isHeartFormat,
    showDebugInfo
  }), [isHeartFormat, showDebugInfo]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(checkoutOffersContext.Provider, {
    value: value,
    children: children
  });
};
exports.CheckoutOffersProvider = CheckoutOffersProvider;
const useCheckoutOffers = () => (0, _react.useContext)(checkoutOffersContext);
exports.useCheckoutOffers = useCheckoutOffers;